import React, { Component } from 'react';
import { publicEncrypt } from 'crypto';
import { Input, Button, Form, message } from 'antd';
import {
  LockOutlined,
  UserOutlined,
  IdcardOutlined,
  MailOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import styles from './style.less';
import { get, post } from '../../commons/http';
import GISBg from '../../components/gis-bg';
import supermapLogo from '../../assets/logos/supermap.png';
import hautLogo from '../../assets/logos/haut.png';

export default class extends Component {
  state = {
    loading: false,
    allInfo: [],
    publicKey: '',
  };

  componentDidMount() {
    //拿到所有的学号，用于校验是否重复
    const getAllUser = async () => {
      const response = await get('/user/userInfo/all');
      const { data } = response;
      this.setState({ allInfo: data });
    };

    //获取公钥
    const getPublicKey = async () => {
      const response = await get('/user/key');
      const { data } = response;
      window.localStorage.setItem('publicKey', data.key);
      this.setState({ publicKey: data.key });
    };

    getPublicKey();
    getAllUser();
  }

  handleSubmit = async (values) => {
    if (this.state.loading) return;
    const {
      password,
      confirmPassword,
      userName,
      staffId,
      email,
    } = values;
    if (password !== confirmPassword) {
      message.error('两次输入的密码不一致', 1);
      return;
    }
    const rsaPassword = publicEncrypt(
      this.state.publicKey,
      Buffer.from(password)
    ).toString('base64');
    // 学号统一转为去空格字符串，避免前导 0 丢失或类型问题
    const staffIdValue = String(staffId || '').trim();
    const response = await post('/user/register', {
      email,
      name: userName,
      role: 'student', //注册默认为学生，管理员由后台指定
      staffId: staffIdValue,
      password: rsaPassword,
    });
    const { data, code, msg } = response;
    if (code === 0) {
      message.success('注册成功', 1);
      window.localStorage.setItem('token', data.token);
      setTimeout(() => {
        this.props.history.replace('/home/competition/all');
      }, 1000);
    } else {
      message.error(msg || '注册失败，请重试', 2);
    }
  };

  render() {
    const { loading, allInfo } = this.state;

    return (
      <div className={styles.root}>
        <GISBg />
        <div className={styles['register-card']}>
          <div className={styles['logo-row']}>
            <img
              src={supermapLogo}
              alt="超图"
              className={styles['logo-supermap']}
            />
            <span className={styles['logo-divider']} />
            <img
              src={hautLogo}
              alt="河南工业大学"
              className={styles['logo-haut']}
            />
          </div>
          <div className={styles.title}>超图杯 · 河南工业大学校赛报名系统</div>
          <div className={styles.subtitle}>注册账号</div>
          <Form name="register" onFinish={this.handleSubmit} size="large">
            <Form.Item
              name="email"
              rules={[
                { required: true, message: '请输入邮箱' },
                { type: 'email', message: '请输入正确的邮箱地址' },
              ]}
            >
              <Input
                allowClear
                autoFocus
                prefix={<MailOutlined />}
                placeholder="邮箱"
              />
            </Form.Item>
            <Form.Item
              name="staffId"
              validateFirst
              rules={[
                { required: true, message: '请输入学号' },
                {
                  type: 'string',
                  max: 20,
                  message: '学号长度不超过20个字符',
                },
                {
                  type: 'string',
                  min: 4,
                  message: '学号长度不低于4位',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const result = allInfo.find((item) => {
                      return value === item.staffId;
                    });
                    if (result) {
                      return Promise.reject('学号已注册');
                    } else {
                      return Promise.resolve();
                    }
                  },
                }),
              ]}
            >
              <Input
                allowClear
                prefix={<IdcardOutlined />}
                placeholder="学号"
              />
            </Form.Item>
            <Form.Item
              name="userName"
              rules={[
                { required: true, message: '请输入姓名' },
                {
                  type: 'string',
                  max: 20,
                  message: '姓名长度不超过20个字符',
                },
              ]}
            >
              <Input
                allowClear
                prefix={<UserOutlined />}
                placeholder="姓名"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: '请输入密码' },
                {
                  type: 'string',
                  min: 6,
                  message: '密码长度不能低于6位',
                },
                {
                  type: 'string',
                  max: 20,
                  message: '密码长度不能高于20位',
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="密码"
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              rules={[
                { required: true, message: '请再次输入密码' },
                {
                  type: 'string',
                  min: 6,
                  message: '密码长度不能低于6位',
                },
                {
                  type: 'string',
                  max: 20,
                  message: '密码长度不能高于20位',
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="确认密码"
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: 8 }}>
              <Button
                className={styles['submit-btn']}
                loading={loading}
                type="primary"
                htmlType="submit"
                block
              >
                注册
              </Button>
            </Form.Item>
          </Form>
          <div className={styles['to-login']}>
            已有账号？
            <Link to="/login">立即登录</Link>
          </div>
        </div>
      </div>
    );
  }
}